const getters = {
    userAccount: state => state.userAccount.userAccount,
}
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js